import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: config.VUE_APP_REGISTRODESHABILITADO ? '/seguimiento': '/solicitud-certificado'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "general" */ '../components/HelloWorld.vue')
  },
  {
    path: '/seguimiento',
    name: 'SeguimientoSolicitud',
    component: () => import(/* webpackChunkName: "formularios" */ '../components/forms/SeguimientoSolicitud.vue')
  }
].concat(config.VUE_APP_REGISTRODESHABILITADO ? []:[  
  {
    path: '/solicitud-certificado',
    name: 'SolicitudCertificado',
    component: () => import(/* webpackChunkName: "formularios" */ '../components/forms/SolicitudCertificado.vue')
  }
])

const router = new VueRouter({
  routes
})

export default router
